import React from 'react'
import { i18n } from '@fs/zion-locale'
import { baseUrl } from '@fs/zion-config'
import StructuredData from './StructuredData'
import { getRootsTechOrganizationData } from './OrganizationStructuredData'

const getSearchActionType = () => {
  return {
    '@type': 'SearchAction',
    target: `${baseUrl}/rootstech/search?f.text={search_term_string}`,
    'query-input': 'required name=search_term_string',
  }
}

export const getWebSiteData = (locale, includeParentOrgs = true) => {
  return {
    '@type': 'WebSite',
    url: `${baseUrl}/rootstech`,
    name: 'RootsTech',
    description:
      'RootsTech.org is the official website of RootsTech, the world’s largest family history and genealogy conference. It provides registration, schedules, speaker information, exhibitor details, on-demand classes, and resources for both in-person and online attendees worldwide.',
    publisher: getRootsTechOrganizationData(includeParentOrgs),
    potentialAction: getSearchActionType(),
    inLanguage: locale,
  }
}

export default function WebSiteStructuredData() {
  const userLocale = i18n.language
  const structuredData = getWebSiteData(userLocale)

  return <StructuredData data={structuredData} dataTestId="website-structured-data" />
}
